/**
 * Landing page variant registry.
 * Maps URL ?v= tags to config slugs.
 *
 * Default when ?v= is omitted or unknown: lyfe.
 * Legacy ?v= tags resolve to lyfe-execution for bookmark compatibility.
 */
export const variantRegistry = {
  a: 'home-rebuild',
  b: 'home-rebuild',
  '1': 'execution-plan',
  '2': 'lyfe-execution',
  '2a': 'lyfe-execution',
  '2b': 'lyfe-execution',
  '3': 'lyfe',
  '4': 'lyfe-execution',
  '5': 'lyfe-execution',
  'execution-plan': 'execution-plan',
  lyfe: 'lyfe',
  'landing-rebuild': 'home-rebuild',
  'home-rebuild': 'home-rebuild',
  'precisiontrader-emotional-discipline-variant': 'lyfe',
  'consistent-trading-habits': 'consistent-trading-habits',
  'lyfe-execution': 'lyfe-execution',
};

/** Default ?v= when param missing or not in registry */
export const defaultVariantTag = 'a';

/**
 * Resolve variant tag to config slug.
 * @param {string} tag - From URL ?v= param
 * @returns {string} Config slug for getLandingConfig
 */
export const resolveVariant = (tag) => {
  if (!tag || typeof tag !== 'string') return variantRegistry[defaultVariantTag];
  const slug = variantRegistry[tag.trim().toLowerCase()];
  return slug || variantRegistry[defaultVariantTag];
};
